module.exports = __webpack_public_path__ + "static/media/video-worry-time-en.0e928df7.vtt";